import { render, staticRenderFns } from "./CarShopAudit.vue?vue&type=template&id=06adddd9&scoped=true"
import script from "./CarShopAudit.vue?vue&type=script&lang=ts"
export * from "./CarShopAudit.vue?vue&type=script&lang=ts"
import style0 from "./CarShopAudit.vue?vue&type=style&index=0&id=06adddd9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06adddd9",
  null
  
)

export default component.exports